import React from "react";

// Components
import MedicalRecordsPanel from "../../components/MedicalRecordsPanel";
import SectionWrapper from "../../components/SectionWrapper";
import MedicalRecordsRoutes from "./MedicalRecordsRoutes";
import MedicalRecordsPanelLayout from "./MedicalRecordsPanelLayout";

const MedicalRecordsPage = () => (
  <SectionWrapper>
    <MedicalRecordsPanelLayout>
      <MedicalRecordsPanel />
    </MedicalRecordsPanelLayout>
    <MedicalRecordsRoutes />
  </SectionWrapper>
);

export default MedicalRecordsPage;
